<div class="dynamic-dialog-surface">
    <div class="dynamic-dialog-card-cross-area">
        <mat-icon (click)="crossClicked()" fontSet="fa-solid" fontIcon="fa-xmark"></mat-icon>
    </div>
    <div class="dynamic-dialog-card-data-area">
        <table>
            <tr class="dynamic-dialog-card-header-tr">
                <th *ngFor="let col of tableColumns">{{ col.fieldName }}</th>
            </tr>
            <tr class="dynamic-dialog-card-data-tr" *ngFor="let dataItem of tableData">
                <td *ngFor="let col of tableColumns">{{ dataItem[col.fieldId] }}</td>
            </tr>
        </table>
    </div>
</div>
